import { t, tg } from '@/config/i18n';

export default {
  install: app => {
    // function to format our translation keys into i18n format
    app.config.globalProperties.$t = t;

    // Add tg function to use gender key
    app.config.globalProperties.$tg = tg;

    app.provide('t', t);
    app.provide('tg', tg);
  }
};
